import React from "react";
import { Link } from "react-router-dom";
import {
  fakeCompanyNameFromCompanyName,
  usePrivacyMode,
} from "../../context-providers/Privacy";
import { useSafeReportMetadata } from "../../pages/specialty-assistant/data";
import { parseReportLink } from "./links";
import styles from "./CommentMessage.module.css";

type CommentLinkProps = {
  href: string;
};

// Renders a URL from a comment, opening in a new tab. Links to our own report
// pages open in this app and show the company name when it is known; anything
// else is a plain link.
export const CommentLink: React.FC<CommentLinkProps> = ({ href }) => {
  const reportLink = parseReportLink(href, window.location.origin);
  const { privacyModeEnabled } = usePrivacyMode();
  // Dashboard.tsx loads the same list around every page with comments, so this
  // adds no request.
  const name = useSafeReportMetadata(reportLink?.reportId)?.report_metadata
    .company_info.company_name;
  const companyName =
    name && privacyModeEnabled ? fakeCompanyNameFromCompanyName(name) : name;
  if (reportLink) {
    return (
      <Link
        to={reportLink.to}
        title={href}
        target="_blank"
        rel="noopener noreferrer"
        className={companyName ? styles.reportLink : styles.link}
      >
        {companyName ? (
          <>
            <i className={`pi pi-file ${styles.reportLinkIcon}`} />
            {companyName}
          </>
        ) : (
          href
        )}
      </Link>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
    >
      {href}
    </a>
  );
};
